var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"detail"}},[_c('div'),_c('div',{staticClass:"buy relativeItem whiteB"},[_c('p',{staticClass:"p1"},[_vm._v("￥800.00")]),_c('button',{staticClass:"absoluteItem centerY radius3",on:{"click":_vm.buy}},[_vm._v("立即购买")])])])}
var staticRenderFns = []

export { render, staticRenderFns }